<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/rw8Nge/tc-custom/9781418573256.jpg?1705239536076" alt="This image is the cover for the book South Carolina Trivia"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">South Carolina Trivia
      </h1>
      <p class="bookDescription body article font2">
        <b>Test your Palmetto State knowledge with this trivia book covering its rich history, geography, sports, culture, notable figures, and more!</b><br/><br/>As one of the original thirteen colonies and the site of the first Civil War battle, South Carolina is a fascinating state, and <i>South Carolina Trivia</i> is full of facts to prove it. This book is the ultimate resource on the who, what, when, where, why, and how of the Palmetto State. <br/><br/>Filled with curious questions and fascinating answers, <i>South Carolina Trivia</i> will provide hours of entertainment and education. Easily adaptable for use with trivia format games, it focuses on the history, culture, people, and places of California.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Al Menendez, Shirley Menendez
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Thomas Nelson
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7d1e0f5f